import { CardioExercise, StrengtheningExercise } from '@/jsonapi/PatientExercise'

const STRENGTHENING_EXERCISE_NAMES = [
  'Overhead Lift',
  'Biceps Curl',
  'Triceps',
  'Heel Raises',
  'Stand to Sit',
  'Arm TB',
  'Leg TB',
]

const CARDIO_EXERCISE_NAMES = ['Elliptical', 'Jogging', 'Skipping']

export const DEFAULT_STRENGTHENING_EXERCISES: StrengtheningExercise[] = STRENGTHENING_EXERCISE_NAMES.map(name => ({
  type: 'strength',
  order: null,
  exerciseName: name,
  sets: null,
  equipment: null,
  resistance: null,
  reps: null,
  feedbackRating: null,
  feedbackMoreWorkLoad: null,
  comments: null,
}))

export const EMPTY_STRENGTHENING_EXERCISE: StrengtheningExercise = {
  type: 'strength',
  order: null,
  exerciseName: null,
  sets: null,
  equipment: null,
  resistance: null,
  reps: null,
  feedbackRating: null,
  feedbackMoreWorkLoad: null,
  comments: null,
}

export const EMPTY_CARDIO_EXERCISE: CardioExercise = {
  type: 'cardio',
  order: null,
  exerciseName: '',
  sets: null,
  equipment: null,
  resistance: null,
  bloodOxygenPerc: null,
  heartRateBpm: null,
  workload: null,
  timeMin: null,
  borgScale: null,
  o2Ipm: null,
  feedbackRating: null,
  feedbackMoreWorkLoad: null,
  comments: null,
}

export const DEFAULT_CARDIO_EXERCISE: CardioExercise = {
  type: 'cardio',
  order: null,
  exerciseName: '',
  sets: null,
  equipment: null,
  resistance: null,
  bloodOxygenPerc: null,
  heartRateBpm: null,
  workload: null,
  timeMin: null,
  borgScale: null,
  o2Ipm: null,
  feedbackRating: null,
  feedbackMoreWorkLoad: null,
  comments: null,
}

export const DEFAULT_CARDIO_EXERCISES: CardioExercise[] = CARDIO_EXERCISE_NAMES.map(name => ({
  type: 'cardio',
  order: null,
  exerciseName: name,
  sets: null,
  equipment: null,
  resistance: null,
  bloodOxygenPerc: null,
  heartRateBpm: null,
  workload: null,
  timeMin: null,
  borgScale: null,
  o2Ipm: null,
  feedbackRating: null,
  feedbackMoreWorkLoad: null,
  comments: null,
}))
